import React from 'react';

import { createComponent, Layout, Header, Label, enums, PropTypes } from 'console-kit';

import authStatics from '../../../common/static';
import AuthImageLogo from '../../../components/AuthImageLogo';

const ErrorCdSsoPanel = createComponent({
  displayName: 'ErrorCdSsoPanel',
  propTypes:   {
    message: PropTypes.string,
  },
  defaultProps: {
    message: undefined,
  },
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES}>
        <Layout isFluidHeight>
          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.CENTER}>
              <AuthImageLogo />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Header
                text="Error signing in"
                isDividing={false}
                font={{
                  emphasis: enums.font.emphasis.NORMAL,
                }}
                size={enums.sizes.X6}
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text="Error when performing the Single-Sign-On"
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>

          <If condition={props.message}>
            <Layout.Row>
              <Layout.Column textAlign={enums.textAlignments.LEFT}>
                <Label
                  text={props.message}
                  hasPadding={false}
                  display={enums.display.PLAIN}
                  size={enums.sizes.X4}
                  isFluid
                />
              </Layout.Column>
            </Layout.Row>
          </If>
        </Layout>
      </div>
    );
  },
});

export default ErrorCdSsoPanel;
